<template>
  <div class="shop-landing">
    <div class="welcome-section">
      <h1 v-if="shopName">
        {{ shopName }} shop
      </h1>
      <h4 v-if="shopWelcomeMessage">
        {{ shopWelcomeMessage }}
      </h4>
    </div>
    <FeaturedProducts :products="featuredProducts" />
    <CategoryGrid :categories="categories" @changeCategory="changeCategory" />
  </div>
</template>
<script>
import FeaturedProducts from './featured_products';
import CategoryGrid from '../category_grid';
export default {
  components: { CategoryGrid, FeaturedProducts},
  props: {
    featuredProducts: { required: true, type: Array, default() { return []; }},
    categories: { required: true, type: Array, default() { return []; }},
    shopName: { required: true, type: String },
    shopWelcomeMessage: { required: true, type: String },
  },
  methods: {
    changeCategory: function(categoryId) {
      this.$emit('changeCategory', categoryId);
    },
  },
};
</script>
